import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { LayoutDashboard, CalendarDays, Scale, TestTube, Menu, Apple, Pill, Crown, Lock, ChevronRight } from "lucide-react";

const MAIN = [
  { v: "overview", label: "Home", icon: LayoutDashboard },
  { v: "diet", label: "Dieta", icon: CalendarDays },
  { v: "weight", label: "Peso", icon: Scale },
  { v: "blood", label: "Analisi", icon: TestTube },
];
const MORE = [
  { v: "foods", label: "Alimenti", desc: "Preferiti e lista su misura", icon: Apple, limited: true },
  { v: "supplements", label: "Integratori", desc: "Il tuo protocollo consigliato", icon: Pill, limited: true },
  { v: "subscription", label: "Abbonamento", desc: "Piano, codici sconto e account", icon: Crown, limited: false },
];

export const BottomNav = ({ tab, onChange, isPremium }) => {
  const [open, setOpen] = useState(false);
  const moreActive = MORE.some((m) => m.v === tab);
  const go = (v) => {
    onChange(v);
    setOpen(false);
    setTimeout(() => {
      const el = v === "overview" ? null : document.getElementById("dash-content");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      else window.scrollTo({ top: 0, behavior: "smooth" });
    }, 50);
  };

  const Item = ({ active, icon: Ic, label, onClick, testid }) => (
    <button onClick={onClick} data-testid={testid}
      className={`relative flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 rounded-2xl transition-colors ${active ? "text-white" : "text-muted-foreground"}`}>
      {active && <span className="absolute inset-x-2 inset-y-0 rounded-2xl bg-brand shadow-md shadow-purple-500/30 pop-in" />}
      <Ic className="relative h-5 w-5" />
      <span className="relative text-[11px] font-medium">{label}</span>
    </button>
  );

  return (
    <>
      <nav className="sm:hidden fixed inset-x-0 bottom-0 z-50 border-t bg-background/90 backdrop-blur-xl px-2 pt-1.5 pb-[calc(0.375rem+env(safe-area-inset-bottom))]" data-testid="bottom-nav">
        <div className="flex items-stretch gap-1">
          {MAIN.map(({ v, label, icon }) => (
            <Item key={v} active={tab === v} icon={icon} label={label} onClick={() => go(v)} testid={`bottom-nav-${v}`} />
          ))}
          <Item active={moreActive || open} icon={Menu} label="Altro" onClick={() => setOpen(true)} testid="bottom-nav-more" />
        </div>
      </nav>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-3xl pb-[calc(1.5rem+env(safe-area-inset-bottom))]" data-testid="bottom-nav-sheet">
          <SheetHeader className="text-left">
            <SheetTitle className="font-heading">Altre sezioni</SheetTitle>
            <SheetDescription>Tutto il tuo percorso DietFlix.</SheetDescription>
          </SheetHeader>
          <div className="mt-4 space-y-2 stagger">
            {MORE.map(({ v, label, desc, icon: Ic, limited }) => (
              <button key={v} onClick={() => go(v)} data-testid={`bottom-nav-more-${v}`}
                className={`w-full flex items-center gap-3 rounded-2xl border p-3 text-left card-lift ${tab === v ? "border-primary/50 bg-primary/5" : "bg-card"}`}>
                <span className="h-10 w-10 rounded-xl bg-secondary grid place-items-center"><Ic className="h-5 w-5 text-primary" /></span>
                <span className="flex-1">
                  <span className="block font-medium text-sm">{label}</span>
                  <span className="block text-xs text-muted-foreground">{desc}</span>
                </span>
                {limited && !isPremium ? <Lock className="h-4 w-4 text-accent" /> : <ChevronRight className="h-4 w-4 text-muted-foreground" />}
              </button>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
